import { Serializable } from 'ts-serializable';
import Token from './token';

class Session extends Serializable {
  token: Token = new Token();
  isLogged: boolean = false;
  isCompletedInitialServices: boolean = false;
}
export default Session;
